import axios from 'axios';
import router from '../router';
import store from '@/store';

const URL = process.env.VUE_APP_API_HOST;
const instance = axios.create({
  baseURL: URL,
  withCredentials: false,
  maxContentLength: Infinity,
  maxBodyLength: Infinity
});

instance.interceptors.request.use((request) => {
  request.headers['Accept'] = 'application/json, text/html';
  request.headers['Content-Type'] = 'application/json';
  request.headers['Authorization'] = `Bearer ${store.state.forgot_password_token ? store.state.forgot_password_token : localStorage.getItem('landing_token')}`;
  return request;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status == 401) {
      const requestUrl = error.config?.url || ''
      const isAuthSideEffect = requestUrl.includes('is-sys-admin') || requestUrl.includes('is-authenticated')

      if (!isAuthSideEffect) {
        localStorage.removeItem('landing_token')
        localStorage.setItem('systems_logged_in', 0)
        router.push('/').catch(() => {})
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
